import { ComponentProps, FC, memo } from 'react'

import { useTranslation } from '@crew/modules/i18n'

/**プレースホルダ表示コンポーネント */
export const PlaceHolder: FC<ComponentProps<'div'> & { text?: string }> = memo(
  (props) => {
    const { t } = useTranslation()
    const { text, ...rest } = props
    return <div {...rest}>{text ?? t('message.chat.enterYourMessage')}</div>
  }
)
